export default __webpack_public_path__ + "static/media/banner-desk.7570a68e.webp";